import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { ProductAction } from 'src/actions/product.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    MAXIMUM_IMAGES,
    MAXIMUM_PRICES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";

const CreateEditDialog = (props) => {
    const maximumImages = MAXIMUM_IMAGES;
    const maximumPrices = MAXIMUM_PRICES;
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.product)

    const [name, setName] = useState("");
    const [price, setPrice] = useState(0);
    const [price_new, setPriceNew] = useState(0);
    const [description, setDescription] = useState("");
    const [short_description, setShortDescription] = useState("");
    const [trang_thai, setTrangThai] = useState("con_hang")
    const [product_type, setProductType] = useState("-99")
    const [images, setImages] = useState({});
    const [prices, setPrices] = useState({});

    const handleImageUpload = (index = 0, inputName, value) => {
        setImages({
            ...images,
            [index]: {
                ...images[index],
                [inputName]: value,
            },
        });
    };

    const setPriceCombo = (index = 0, inputName, value) => {
        setPrices({
            ...prices,
            [index]: {
                ...prices[index],
                [inputName]: value,
            },
        });
    };

    const deleteBannerIndex = (index = 0) => {
        const newImages = { ...images };

        delete newImages[index];

        setImages(newImages);
    };

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
        dispatch(PermissionAction.list(0, 100))
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setName(selected.name)
                setPrice(selected.price)
                setPriceNew(selected.price_new)
                setDescription(selected.description)
                setShortDescription(selected.short_description)
                setTrangThai(selected.trang_thai)
                setProductType(selected.product_type)

                // const _images = {};
                // if (selected.images && selected.images.length > 0) {
                //     for (let i = 0; i < selected.images.length; i++) {
                //         _images[selected.images[i].index] = selected.images[i].image;
                //     }
                // }

                const _images = {};

                if (selected.images && selected.images.length > 0) {
                    const sortedImages = [...selected.images].sort((a, b) => a.index - b.index);

                    sortedImages.forEach((img, i) => {
                        _images[i] = {
                            image: img.image,
                            color_code: img.color_code,
                            color_name: img.color_name,
                        }
                    });
                }

                setImages(_images)

                const _prices = {};

                if (selected.prices && selected.prices.length > 0) {
                    const sortedPrices = [...selected.prices].sort((a, b) => {
                        const aHasName = a.name && a.name.trim() !== '';
                        const bHasName = b.name && b.name.trim() !== '';
                      
                        // Ưu tiên item có name hợp lệ
                        if (aHasName && !bHasName) return -1;
                        if (!aHasName && bHasName) return 1;
                      
                        // Nếu cả 2 đều cùng trạng thái name => sort theo index
                        return a.index - b.index;
                    });

                    sortedPrices.forEach((price, i) => {
                        _prices[i] = {
                            id: price.id,
                            name: price.name,
                            price: price.price,
                            price_new: price.price_new,
                        }
                    });
                }

                setPrices(_prices)
            }
        }
    }, [selected])

    const onPressPositive = async () => {
        console.log("images:", images);
        console.log("description:", description);

        if (name === "") {
            alert("Vui lòng nhập tên!");
            return;
        }
        if (Object.values(images).filter(value => value != null).length < 1) {
            alert("Vui lòng chọn ít nhất 1 hình ảnh");
            return;
        }
        if (Object.values(prices).filter(value => value != null).length < 1) {
            alert("Vui lòng nhập ít nhất 1 khung giá");
            return;
        }
        // if (price === "" || Number(price) < 1) {
        //     alert("Vui lòng nhập giá!");
        //     return;
        // }
        if (description === "") {
            alert("Vui lòng nhập mô tả!");
            return;
        }
        if (short_description === "") {
            alert("Vui lòng nhập mô tả ngắn!");
            return;
        }
        if (trang_thai === "" || trang_thai == "-99") {
            alert('Vui lòng chọn trạng thái!');
            return;
        }
        if (product_type === "" || product_type == "-99") {
            alert('Vui lòng chọn loại sản phẩm!');
            return;
        }

        console.log(images);
        const _images = [];
        for (let i = 0; i < maximumImages; i++) {
            if (typeof images[i] !== 'undefined' && images[i]) {
                _images.push({
                    index: i,
                    image: images[i].image,
                    color_code: images[i].color_code,
                    color_name: images[i].color_name,
                })
            }
        }

        const _prices = [];
        for (let i = 0; i < maximumPrices; i++) {
            if (typeof prices[i] !== 'undefined' && prices[i]) {
                _prices.push({
                    index: i,
                    id: prices[i].id,
                    name: prices[i].name,
                    price: prices[i].price,
                    price_new: prices[i].price_new,
                })
            }
        }

        if (props.type === 'EDIT') {
            dispatch(ProductAction.update(selected.id, { 
                images: _images,
                prices: _prices,
                name,
                price,
                price_new,
                description,
                short_description,
                trang_thai,
                product_type,
            }))
            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(ProductAction.create({ 
                    images: _images,
                    prices: _prices,
                    name,
                    price,
                    price_new,
                    description,
                    short_description,
                    trang_thai,
                    product_type,
                }))
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
        
    }

    const resetState = () => {
        setName("")
        setImages({})
        setPrices({})
        setPrice(0)
        setPriceNew(0)
        setDescription("")
        setShortDescription("")
        setTrangThai("con_hang")
        setProductType("-99")
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedPermissionIds.indexOf(id);
        let newSelectedCustomerIds = [];
        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds, id);
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(1));
        } else if (selectedIndex === selectedPermissionIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedPermissionIds.slice(0, selectedIndex),
                selectedPermissionIds.slice(selectedIndex + 1)
            );
        }
        setSelectedPermissionIds(newSelectedCustomerIds);
    };

    const setColor = (value) => {
        if (value == 'MOBIFONE') return 'green';
        else if (value == 'VINAPHONE') return 'blue';
        else if (value == 'VIETTEL') return 'red';
        else return '#000000';
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog open={props.open} onClose={props.handleClose}>
                <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
                <DialogContent style={{ width: 600, paddingTop: 20 }}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Tên"
                                name="name"
                                onChange={(e) => setName(e.target.value)}
                                required
                                value={name}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="trang_thai"
                                value={trang_thai || -99}
                                onChange={(e) => setTrangThai(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                            >
                                <MenuItem value="-99">Trạng thái...</MenuItem>
                                <MenuItem value="con_hang">Còn hàng</MenuItem>
                                <MenuItem value="het_hang">Hết hàng</MenuItem>
                            </Select1>
                        </Grid>
                        {/* <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Giá"
                                name="price"
                                onChange={(e) => setPrice(e.target.value)}
                                required
                                value={price}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Giá khuyến mãi"
                                name="price_new"
                                onChange={(e) => setPriceNew(e.target.value)}
                                value={price_new}
                                variant="outlined"
                            />
                        </Grid> */}
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="product_type"
                                value={product_type || -99}
                                onChange={(e) => setProductType(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Loại sản phẩm...</MenuItem>
                                <MenuItem value="xe_may_dien">Xe máy điện</MenuItem>
                                <MenuItem value="xe_dap_dien">Xe đạp điện</MenuItem>
                                <MenuItem value="ac_quy">Ắc quy</MenuItem>
                                <MenuItem value="pin">Pin</MenuItem>
                                <MenuItem value="phu_tung">Phụ tùng</MenuItem>
                                <MenuItem value="khac">Khác</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Mô tả ngắn *
                            </Typography>
                            <div>
                                <PostEditor
                                    onChange={(value) => {
                                        setShortDescription(value);
                                    }}
                                    initialContent={short_description !== "" ? short_description : ""}
                                />
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Mô tả *
                            </Typography>
                            <div>
                                <PostEditor
                                    onChange={(value) => {
                                        setDescription(value);
                                    }}
                                    initialContent={description !== "" ? description : ""}
                                />
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Giá theo combo *<br></br>
                                <span style={{color: 'gray', fontSize: '80%'}}>Tối đa {maximumPrices} giá</span>
                            </Typography>
                        </Grid>
                        {Array.from({ length: maximumPrices }).map((_, index) => (<>
                            <Grid item md={4} xs={4} key={index}>
                                <TextField
                                    fullWidth
                                    label="Tên combo"
                                    name="name"
                                    onChange={(e) => setPriceCombo(index, 'name', e.target.value)}
                                    required
                                    value={prices[index] && prices[index].name ? prices[index].name : ""}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item md={4} xs={4} key={index}>
                                <TextField
                                    fullWidth
                                    label="Giá"
                                    name="price"
                                    onChange={(e) => setPriceCombo(index, 'price', e.target.value)}
                                    required
                                    value={prices[index] && prices[index].price ? prices[index].price : "0"}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item md={4} xs={4} key={index}>
                                <TextField
                                    fullWidth
                                    label="Giá khuyến mãi"
                                    name="price_new"
                                    onChange={(e) => setPriceCombo(index, 'price_new', e.target.value)}
                                    value={prices[index] && prices[index].price_new ? prices[index].price_new : "0"}
                                    variant="outlined"
                                />
                            </Grid>
                        </>))}
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Hình ảnh *<br></br>
                                <span style={{color: 'gray', fontSize: '80%'}}>Tối đa {maximumImages} ảnh</span>
                            </Typography>
                        </Grid>
                        {Array.from({ length: maximumImages }).map((_, index) => (
                            <Grid item md={3} xs={6} key={index}>
                                <Typography className='checkbox-container' variant="body1">
                                    Ảnh {index + 1}
                                    {images[index] && <Button style={{width: 20, minWidth: 20, height: 20, padding: 0, margin: "0 0 5px 5px"}} color="error" variant="contained" onClick={() => {deleteBannerIndex(index)}}>
                                        X
                                    </Button>}
                                    {/* <TextField
                                        fullWidth
                                        placeholder='#000000'
                                        className="color_code_text_input"
                                        onChange={(e) => handleImageUpload(index, 'color_code', e.target.value)}
                                        value={images[index] && images[index].color_code ? images[index].color_code : ""}
                                        variant="outlined"
                                    /> */}
                                    <TextField
                                        fullWidth
                                        placeholder='Màu sắc'
                                        className="color_code_text_input"
                                        onChange={(e) => handleImageUpload(index, 'color_name', e.target.value)}
                                        value={images[index] && images[index].color_name ? images[index].color_name : ""}
                                        variant="outlined"
                                    />
                                </Typography>
                                <div style={{ width: "100%" }}>
                                    <ImageUploader
                                        onUploadSuccess={(imageUrl, uploaderIndex) => handleImageUpload(uploaderIndex, 'image', imageUrl)}
                                        initialImage={images[index] && images[index].image ? images[index].image : ""}
                                        uploaderIndex={index}
                                    />
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions>
            </Dialog >
        </LocalizationProvider>
    );
}

export default CreateEditDialog;